import React from "react";

interface KPICardProps {
  label: string;
  value: string | number;
  sub?: string;
  color?: "default" | "success" | "danger" | "warning" | "info";
}

const colorMap: Record<string, string> = {
  default: "#e2e8f0",
  success: "#22c55e",
  danger:  "#ef4444",
  warning: "#f59e0b",
  info:    "#3b82f6",
};

const KPICard: React.FC<KPICardProps> = ({ label, value, sub, color = "default" }) => (
  <div
    style={{
      background: "var(--surface)",
      borderRadius: 10,
      padding: "18px 20px",
      borderLeft: `4px solid ${colorMap[color]}`,
      border: "1px solid var(--border)",
      borderLeftWidth: 4,
      display: "flex",
      flexDirection: "column",
      gap: 6,
    }}
  >
    <span style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
      {label}
    </span>
    <span style={{ fontSize: 26, fontWeight: 700, color: colorMap[color] }}>
      {value}
    </span>
    {sub && <span style={{ fontSize: 12, color: "var(--muted)" }}>{sub}</span>}
  </div>
);

export default KPICard;
